import 'css/src/global';

import React from 'react';

import Sidebar from '../common/Sidebar';
import Title from '../common/Title';

import LoginForm from './LoginForm';

import { Urls } from 'js/src/client';
import Copyright from 'js/src/components/auth/common/Copyright';
import { getCurrentPathWithNext } from 'js/src/data/account/utils';

const LoginPage = React.memo(function LoginPage() {
    return (
        <div className="row" data-testid="login-page">
            <div className="col-xl-4 d-none d-xl-block">
                <Sidebar />
            </div>

            <div className="col-xl-8 col-sm-12 d-flex justify-content-center">
                <div className="details-form">
                    <div className="form-sidebar vertical-flex">
                        <div className="flex-spacer">
                            {/* Spaces out top in the form on desktop */}
                            <div className=" auth-base-logo d-block d-xl-none mb-l5-48">
                                <a href={Urls.HOME}>
                                    <img
                                        src="https://cdn.lumen5.com/lumen5-site-images/L5-logo/2024/Lumen5-PrimaryLogo.svg"
                                        alt="Lumen5"
                                        width="125"
                                    />
                                </a>
                            </div>
                        </div>
                        <div className="login-form main-content">
                            <Title title={'Welcome back!'} />
                            <LoginForm
                                facebookAuthUrl={Urls.FACEBOOK_AUTH}
                                googleAuthUrl={Urls.GOOGLE_AUTH}
                                currentPath={getCurrentPathWithNext()}
                                forgotPasswordUrl={Urls.FORGOT_PASSWORD}
                            />
                        </div>
                        <Copyright />
                    </div>
                </div>
            </div>
        </div>
    );
});

export default LoginPage;
